import { render } from "./RegionSlider.vue?vue&type=template&id=139db3b2"
import script from "./RegionSlider.vue?vue&type=script&lang=js"
export * from "./RegionSlider.vue?vue&type=script&lang=js"

import "./RegionSlider.vue?vue&type=style&index=0&id=139db3b2&lang=stylus"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__